export default __webpack_public_path__ + "static/media/fb.3bfab3e0.png";